interface ProjectStatusBadgeProps {
    status: string;
}

export const ProjectStatusBadge = ({ status }: ProjectStatusBadgeProps) => {
    const normalize = (s: string) => s?.trim() || '';

    const toKebab = (s: string) => splitCamel(s).toLowerCase().replace(/\s+/g, '-');

    const splitCamel = (s: string) => s.replace(/([a-z])([A-Z])/g, '$1 $2');

    const getStatusClass = (raw: string): string => {
        const k = toKebab(normalize(raw));

        switch (k) {
            case 'in-progress':
                return 'status-badge--in-progress';
            case 'completed':
                return 'status-badge--paid';
            case 'on-hold':
                return 'status-badge--on-hold';
            case 'cancelled':
                return 'status-badge--overdue';
            case 'kick-off':
                return 'status-badge--kick-off';
            default:
                return 'status-badge--draft';
        }
    };

    const formatStatusLabel = (raw: string): string => {
        if (!raw) return 'Not Set';
        return splitCamel(raw)
            .split(' ')
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' ');
    };

    return <span className={`status-badge ${getStatusClass(status)}`}>{formatStatusLabel(status)}</span>;
};
